"use strict";

let toExport = {};

if(!process.env.GCLOUD_PROJECT_ON_BUILD && process.env.GCLOUD_PROJECT) {
  process.env.GCLOUD_PROJECT_ON_BUILD = process.env.GCLOUD_PROJECT;
}

let links = {
  site: {
    name: 'Site',
    link: process.env.VUE_APP_SITE_URL
  },
  /* facebook: {
     name: 'Facebook',
     link: 'https://www.facebook.com/Sauver-112736837169018'
   },
   instagram: {
     name: 'Instagram',
     link: 'https://www.instagram.com/sauver_med'
   } */
};


const android = {
  linkStore: 'https://play.google.com/store/apps/details?id=br.com.justworks.voxtom3',
  storeCode: '',
  id: 'br.com.justworks.voxtom3',
  uri: 'vnd.voxtom://',
  name: 'Voxtom',
  packageName: 'br.com.justworks.voxtom3'
};

const ios = {
  linkStore: 'https://apps.apple.com/br/app/voxtom/id6563141890',
  storeCode: 'id6563141890',
  id: 'id6563141890',
  uri: 'vnd.voxtom://',
  name: 'Voxtom',
  packageName: '',
};

toExport.config = {
    name: `VOXGO ${!(process.env.NODE_ENV === 'production' || process.env.VUE_APP_DEVELOPER_DATABASE_MODE === 'production')?' DEV ':''}`,
    maps: {
      key: process.env.VUE_APP_MAP_KEY
    },
    title: 'VOXGO'+(!(process.env.NODE_ENV === 'production' || process.env.VUE_APP_DEVELOPER_DATABASE_MODE === 'production')?' DEV ':''),
    description: 'VOXGO!',

    baseUrl: process.env.VUE_APP_BASE_URL,
    firebase: {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID,
      measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
    },
    functionsUrl: process.env.VUE_APP_FUNCTIONS_URL,
    fbId: '446124909121871',
    links: links,
    android: android,
    ios: ios,
    themeColor: '#000000',
    msTileColor: '#000000',
    appleMobileWebAppCapable: 'yes',
    appleMobileWebAppStatusBarStyle: 'black',
    emailKey: process.env.VUE_APP_EMAIL_KEY || 'voxtom.com',
    region: 'southamerica-east1',
    isDevServer: !(process.env.NODE_ENV === 'production' || process.env.VUE_APP_DEVELOPER_DATABASE_MODE === 'production'),
};

toExport.appConfig = toExport.config;

module.exports = toExport;
